
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.89 10.288a1.346 1.346 0 01-.366.932 1.2 1.2 0 01-1.688.07q-.036-.034-.07-.07L7.951 7.181l-3.828 4.053a1.2 1.2 0 01-1.688.071q-.037-.034-.071-.071a1.375 1.375 0 010-1.864l4.707-4.984a1.2 1.2 0 011.691-.066q.036.033.068.068l4.695 4.968a1.355 1.355 0 01.365.932","fill-rule":"evenodd"}})])
          )
        }
      }
    